import callApi, { METHOD_TYPE } from '../utils/callApi'
import { ACTION } from '../mutations'
import { POPUP, RECOMMENDAI, ICON, actionFormat, actionPopupConfigurationFormat, actionRecommendAiConfigurationFormat, actionIconConfigurationFormat } from '../constants'
import { cloneDeep } from 'lodash'

// 代入されるアクションリストの雛形
const state = {
  action: {},
  actionList: [],
  scenarioList: [],
  uploadedImage: '',
  downloadUrl: ''
}

const mutations = {
  [ACTION.ACTION_LIST](state, payload) { state.actionList = payload },
  [ACTION.ACTION_GET](state, payload) {
    state.action = payload
    state.action.model = ''
    state.action.modelExtention = ''
    state.downloadUrl = process.env.NODE_ENV === 'local'
      ? 'https://res.pdq-dev.team-rec.jp/' + state.action.configuration.downloadUrl
      : location.protocol + '//' + location.hostname.replace('console', 'res') + '/' + state.action.configuration.downloadUrl
  },
  [ACTION.SCENARIO_LIST](state, payload) { state.scenarioList = payload },
  [ACTION.MODEL](state, payload) {
    state.action.model = payload.model
    state.action.modelExtention = payload.modelExtention
  },
  [ACTION.UPLOAD_IMAGE](state, payload) {
    state.uploadedImage = payload
  }
}
const actions = {
  createAction({ commit }, router) {
    let createParams = {
      actionId: state.action.actionId,
      metadata: state.action.metadata,
      configuration: {
        type: state.action.metadata.type
      }
    }
    if (state.action.metadata.type === RECOMMENDAI) {
      createParams.configuration.scenarioId = state.action.configuration.scenarioId
    } else if (state.action.metadata.type === ICON) {
      createParams.configuration.positionConfiguration = state.action.configuration.positionConfiguration
      createParams.configuration.textColor = state.action.configuration.textColor
      createParams.configuration.textLinkColor = state.action.configuration.textLinkColor
      createParams.configuration.textBackground = state.action.configuration.textBackground
      createParams.configuration.userTextColor = state.action.configuration.userTextColor
      createParams.configuration.userTextBackground = state.action.configuration.userTextBackground
      createParams.configuration.buttonColor = state.action.configuration.buttonColor
      createParams.configuration.buttonTextColor = state.action.configuration.buttonTextColor
      createParams.configuration.buttonAreaColor = state.action.configuration.buttonAreaColor
      createParams.model = state.action.model
      createParams.modelExtention = state.action.modelExtention
    } else if (state.action.metadata.type === POPUP) {
      createParams.configuration.url = state.action.configuration.url
      createParams.configuration.size = state.action.configuration.size
      createParams.configuration.positionConfiguration = state.action.configuration.positionConfiguration
      createParams.model = state.action.model
      createParams.modelExtention = state.action.modelExtention
    }

    callApi('/delivery/create-action', METHOD_TYPE.POST, createParams)
    .then((response) => {
      alert('アクションの作成に成功しました')
      router.push('/delivery/list-action')
    })
    .catch(e => {
      if (e.response == null) {
        alert('アクションの作成に失敗しました。' + '\n' + e.message)
      } else {
        alert('アクションの作成に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getActionListData({ commit }) {
    callApi('/delivery/list-action', METHOD_TYPE.POST, { })
    .then((response) => {
      commit(ACTION.ACTION_LIST, response.body.actions)
    })
    .catch(e => {
      if (e.response == null) {
        alert('アクションの取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('アクションの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  getActionData({ commit }) {
    callApi('/delivery/get-action', METHOD_TYPE.POST, { 'actionId': state.action.actionId })
    .then((response) => {
      commit(ACTION.ACTION_GET, response.body.action)
    })
    .catch(e => {
      if (e.response == null) {
        alert('アクションの取得に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('アクションの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  formatActionData({ commit }) {
    commit(ACTION.ACTION_GET, cloneDeep(actionFormat))
  },
  updateAction({ commit }, router) {
    let updateParams = {
      actionId: state.action.actionId,
      versionId: state.action.versionId,
      metadata: state.action.metadata,
      configuration: {
        type: state.action.metadata.type
      }
    }
    if (state.action.metadata.type === RECOMMENDAI) {
      updateParams.configuration.scenarioId = state.action.configuration.scenarioId
    } else if (state.action.metadata.type === ICON) {
      updateParams.configuration.positionConfiguration = state.action.configuration.positionConfiguration
      updateParams.configuration.textColor = state.action.configuration.textColor
      updateParams.configuration.textLinkColor = state.action.configuration.textLinkColor
      updateParams.configuration.textBackground = state.action.configuration.textBackground
      updateParams.configuration.userTextColor = state.action.configuration.userTextColor
      updateParams.configuration.userTextBackground = state.action.configuration.userTextBackground
      updateParams.configuration.buttonColor = state.action.configuration.buttonColor
      updateParams.configuration.buttonTextColor = state.action.configuration.buttonTextColor
      updateParams.configuration.buttonAreaColor = state.action.configuration.buttonAreaColor
      updateParams.model = state.action.model
      updateParams.modelExtention = state.action.modelExtention
      updateParams.configuration.downloadUrl = state.action.configuration.downloadUrl
    } else if (state.action.metadata.type === POPUP) {
      updateParams.configuration.url = state.action.configuration.url
      updateParams.configuration.size = state.action.configuration.size
      updateParams.configuration.positionConfiguration = state.action.configuration.positionConfiguration
      updateParams.model = state.action.model
      updateParams.modelExtention = state.action.modelExtention
      updateParams.configuration.downloadUrl = state.action.configuration.downloadUrl
    }
    callApi('/delivery/update-action', METHOD_TYPE.POST, updateParams)
    .then((response) => {
      alert('アクションの更新に成功しました')
      router.push('/delivery/list-action')
    })
    .catch(e => {
      if (e.response == null) {
        alert('アクションの更新に失敗しました。' + '\n' + e.message)
      } else {
        alert('アクションの更新に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  formatConfigurationData({ commit }) {
    if (state.action.metadata.type === 'popup') {
      state.action.configuration = actionPopupConfigurationFormat
    } else if (state.action.metadata.type === 'recommend-ai') {
      state.action.configuration = actionRecommendAiConfigurationFormat
    } else {
      state.action.configuration = actionIconConfigurationFormat
    }
  },
  getScenarioList({ commit }) {
    callApi('/robotalk/list-scenario', METHOD_TYPE.POST, { })
    .then((response) => {
      commit(ACTION.SCENARIO_LIST, response.body.scenarios)
    })
  },
  actionDelete({ commit }, action) {
    callApi('/delivery/delete-action', METHOD_TYPE.POST, { actionId: action.actionId, versionId: action.versionId })
    .then((response) => {
      commit(ACTION.ACTION_LIST, state.actionList.filter(n => n !== action))
    })
    .catch(e => {
      if (e.response == null) {
        alert('アクションの削除に失敗しました。' + '\n' + e.message)
      } else {
        location.href = '#/error/' + e.status
        alert('アクションの削除に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  },
  setModel({ commit }, modelData) {
    commit(ACTION.MODEL, modelData)
  },
  setUploadedImage({ commit }, uploadedImage) {
    commit(ACTION.UPLOAD_IMAGE, uploadedImage)
  }
}

export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/stores/action.js